// ---------------------------------------------------------------
// IMPORTS
// ---------------------------------------------------------------
import { log, errorlog } from '../logger/logger';

// ---------------------------------------------------------------
// DEFAULTS
// ---------------------------------------------------------------
let currentFonts = [];

// ---------------------------------------------------------------
// CLASS
// ---------------------------------------------------------------
export class Fonts {

    constructor() {}

    init() {
        log('font init');
        currentFonts = [{
            displayName: '',
            family: '',
            source: ''
        }];
    }

    set(fonts) {
        set(fonts);
    }

    get() {
        return get();
    }
}

// ---------------------------------------------------------------
// PRIVATE FUNCTIONS
// ---------------------------------------------------------------
function set(fonts) {
    currentFonts = fonts;
    addFontsToDom();
}

function get() {
    return currentFonts;
}

// ---------------------------------------------------------------
// UTIL
// ---------------------------------------------------------------
function addFontsToDom() {
    const uniqueSources = new Set(currentFonts.map(font => font.source));

    const head = $('head');
    uniqueSources.forEach(source => {
        head.append(`<link rel="stylesheet" type="text/css" href="${source}"/>`);
    });
}
